module.exports = __webpack_public_path__ + "static/media/enviar_email.cad7602b.svg";